export const SEARCH_SITE_TABLE_FRENCH_LOCALE = {
  search: "Rechercher",
  empty: "Aucun site trouvé, essayez de modifier les filtres",
  headers: {
    siteId: "Site Id",
    subscriberFirstname: "Prénom",
    subscriberLastname: "Nom",
    siteAddress: "Adresse",
    sitePostalCode: "Code Postale",
    siteCity: "Ville",
    country: "Pays",
  },
};
